export { default } from './es/icons/NoResultTwoTone';